import { GzStorageProtectionExclusionsWebComponent } from './component/GzStorageProtectionExclusionsWebComponent';

export { GzStorageProtectionExclusionsWebComponent };
